import { render } from "./shift-scheduling.vue?vue&type=template&id=5fd5f236"
import script from "./shift-scheduling.vue?vue&type=script&lang=js"
export * from "./shift-scheduling.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__